module.exports = __webpack_public_path__ + "static/Barlow-Regular-3a3ae813a5220d7d4ea6bb11358a0f80.woff2";